(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  //   document.addEventListener('DOMContentLoaded', function() {
  //   const logo = document.querySelector(".footer-large-logo");
  //   const footer = document.querySelector("footer");

  //   if (!logo || !footer) return;

  //   let lastScrollPosition = window.scrollY;
  //   let scale = 1.;
  //   let opacity = 1;

  //   window.addEventListener("scroll", () => {
  //     const currentScrollPosition = window.scrollY;
  //     if (currentScrollPosition < lastScrollPosition) {
  //       scale = Math.max(0.5, scale - 0.01);
  //       opacity = Math.max(0.5, opacity - 0.01);

  //     } else {
  //       scale = Math.min(1, scale + 0.02);
  //       opacity = Math.min(1, opacity + 0.02);
  //     }
  //     logo.style.transform = `scale(${scale})`;
  //     logo.style.opacity = opacity;
  //     logo.style.transition = "transform 0.1s ease, opacity 0.1s ease";
  //     lastScrollPosition = currentScrollPosition;
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback(){
      this.header = document.querySelector('.section-header');
      this.headerIsOnSticky = this.getAttribute('data-sticky-type') === 'sticky';
      if (!this.headerIsOnSticky) return;

      this.header.classList.add('wdt-scroll-sticky');
      const wdtHeaderEle = document.querySelector('.wdt-scroll-sticky');
      const wdt_MaxScroll = 800;
      let wdtHeaderHeight = this.header.offsetHeight;
      let position = window.scrollY;

      const updateHeaderHeight = () => { wdtHeaderHeight = this.header.offsetHeight; };

      window.addEventListener('scroll', function(){
        const wdtScrollTop = window.scrollY;
        if ((wdtScrollTop > 0 && position > wdt_MaxScroll) && wdtScrollTop > position) {
          wdtHeaderEle.classList.add('wdt-header-top');
          wdtHeaderEle.style.top = `-${wdtHeaderHeight}px`;
        } else {
          wdtHeaderEle.classList.remove('wdt-header-top');
          wdtHeaderEle.style.top = '0px';
        }
        position = wdtScrollTop;
      });

      window.addEventListener('resize', updateHeaderHeight);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-target]").forEach((button) => {
      button.addEventListener("click", function () {
        const targetSelector = this.getAttribute("data-target");
        const offcanvasElement = document.querySelector(targetSelector);
        if (offcanvasElement) {
          const bsOffcanvas = new bootstrap.Offcanvas(offcanvasElement);
          bsOffcanvas.show();
        }
      });
    });

    document.querySelectorAll('a[role="button"]').forEach(button => {
      button.addEventListener('keydown', function(e) {
        if (e.code === 'Space' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    const subMenu = () => {
      const dropdown_subMenu = document.querySelectorAll(".dropdown-menu.sub-menu");
      const documentBody = document.querySelector("body");
      const window_Width = documentBody.clientWidth;

      dropdown_subMenu.forEach((item) => {
        const thisItemRight = item.getBoundingClientRect().right;
        if (window_Width < thisItemRight) {
          item.classList.add("wdt_float_left");
        } else {
          item.classList.remove("wdt_float_left");
        }
      });
    };

    subMenu();
    window.addEventListener("resize", subMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  class NewsletterModal extends HTMLElement {
    constructor() {
      super();
      this.newsletterModal = null;
      this.closeButton = null;
    }

    connectedCallback() {     
      this.initModal();
    }

    initModal() {      
      this.newsletterModal = this.querySelector("#newsletter_model");
      this.closeButton = this.querySelector("#newsletter_model .btn-close");

      if (!this.newsletterModal || this.getCookie("newsletter_shown")) {      
        return;
      }
      const isThemeEditor = window.Shopify && window.Shopify.designMode; 
      const delay = parseInt(this.newsletterModal.dataset.delay || "0", 10);
      const expiryDays = parseInt(this.newsletterModal.dataset.expiry || "30", 10);
      
      if (!isThemeEditor && this.getCookie("newsletter_shown")) {     
      return;
    }


      setTimeout(() => {
      this.showModal();
      if (!isThemeEditor) {
        this.setCookie("newsletter_shown", "true", expiryDays);
      }
    }, delay);

    this.initEventListeners();
  }

    initEventListeners() {
      if (this.closeButton) {
        this.closeButton.addEventListener("click", () => this.hideModal());
      }

      document.addEventListener("click", (event) => {
        if (!event.target.closest(".popup-modal, .trigger")) {
          this.hideModal();
        }
      });
    }

   showModal() {
      this.newsletterModal.classList.remove("d-none");
      this.newsletterModal.classList.add("d-flex");
    
      this.newsletterModal.setAttribute("tabindex", "-1");
      this.newsletterModal.setAttribute("role", "dialog");
      this.newsletterModal.setAttribute("aria-modal", "true");
    
      this.newsletterModal.focus();
    
      const firstInput = this.newsletterModal.querySelector(
        'input:not([type="hidden"]):not([disabled]), textarea, select'
      );
    
      if (firstInput) {
        firstInput.focus();
      }
    }


    hideModal() {    
      if (this.newsletterModal) {
        this.newsletterModal.classList.remove("d-flex");
        this.newsletterModal.classList.add("d-none");
        this.newsletterModal.style.setProperty("display", "none", "important");
      }

      const popupModal = this.querySelector(".popup-modal");
      if (popupModal) {
        popupModal.style.setProperty("display", "none", "important");
      }
    }

    getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
    }

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = `${name}=${value || ""}${expires}; path=/`;
    }
  }


  customElements.define("newsletter-modal", NewsletterModal);
  document.addEventListener("DOMContentLoaded", () => {    
    const newsletterModalElement = document.querySelector("newsletter-modal");    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
function initWdtIcon(){
  let wdtIconItem = document.querySelectorAll('.text-with-icon-item');

  wdtIconItem.forEach(wdtItem => {
    let wdtItem_height = wdtItem.clientHeight / 2;
    let wdtItem_parent = wdtItem.closest('.section-text-with-icon');
    wdtItem_parent.setAttribute('style', `--before-top: ${wdtItem_height}px;`);
  });
}
  initWdtIcon();

  } catch(e) { console.error(e); }
})();
})();
